import { createRoute } from '@tanstack/react-router';

import { useMaterialSearchStore } from '$/components/core/Collection/MaterialSearch/store/useMaterialSearchStore';
import { CollectionCategoryPage } from '$/pages/DashboardPages/pages/Collection/pages/CollectionCategoryPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { useCollectionStore } from '$/stores/useCollectionStore';

export const FacadeCollectionsRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/collections/facades',
  component: () => <CollectionCategoryPage materialType='facade_texture' />,
  beforeLoad: () => {
    useCollectionStore.setState({
      activeType: 'facade_texture',
      selectedViewMode: 'grid',
    });
  },
  loader: () => {
    useCollectionStore.setState({
      activeType: 'facade_texture',
      selectedViewMode: 'grid',
    });
    useMaterialSearchStore.setState({
      dropdownVisible: false,
    });
  },
  onLeave: () => {
    useCollectionStore.getState().resetAppliedFilter();
  },
  staleTime: 0,
});
